import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import {
  FormProps,
  RowWrapper,
  Section,
  SectionTitle,
} from '../../../components/AdminFormComponents';
import { FormikSwitchField } from 'lib/components/formik/FormikSwitchField';
import { FormikInputField } from 'lib/components/formik/FormikInputField';
import { Flex } from 'lib/components/styles/layout';
import { useTranslation } from 'react-i18next';

export const AIFeaturesSection = (props: FormProps) => {
  const { t } = useTranslation();
  const { setFieldValue, values } = props;
  const tempDefaultLimits = {
    maxPrompts: 500,
    maxQuickVideoAvatarPerMonth: 200,
    maxVinReelsPerMonth: 1000,
    maxSpotlightPerMonth: 5,
  };
  return (
    <Section>
      <SectionTitle>AI Features</SectionTitle>
      <RowWrapper>
        {/* AI SCRIPTS ASSIST */}
        <Flex>
          <FormikSwitchField
            extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
            name='hasCovideoMagic'
            label={t('Script Assist')}
            onChange={() => {
              setFieldValue('hasCovideoMagic', values.hasCovideoMagic ? 0 : 1);
            }}
          />
          {!!values.hasCovideoMagic && (
            <FormikInputField
              type='number'
              label={t('Limit')}
              name='maxPrompts'
              isRequired={false}
              labelPosition='left'
              value={values.maxPrompts || tempDefaultLimits.maxPrompts}
              info={t(
                'If the limit is set to 0, the default value will be applied.'
              )}
              extendStyles={{
                mainWrapper: { gap: '116px', padding: '0 0 0 23px' },
                labelStyles: { alignSelf: 'flex-start' },
              }}
            />
          )}
        </Flex>

        {/* AI ASSISTANTS */}
        <Flex>
          <FormikSwitchField
            extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
            name='quickVideoAvatarEnabled'
            label={t('AI Video Agents')}
            onChange={() => {
              setFieldValue(
                'quickVideoAvatarEnabled',
                values.quickVideoAvatarEnabled ? 0 : 1
              );
            }}
          />
          {!!values.quickVideoAvatarEnabled && (
            <FormikInputField
              type='number'
              label={t('Limit')}
              name='maxQuickVideoAvatarPerMonth'
              isRequired={false}
              labelPosition='left'
              value={
                values.maxQuickVideoAvatarPerMonth ||
                tempDefaultLimits.maxQuickVideoAvatarPerMonth
              }
              info={t(
                'If the limit is set to 0, the default value will be applied.'
              )}
              extendStyles={{
                mainWrapper: { gap: '116px', padding: '0 0 0 23px' },
                labelStyles: { alignSelf: 'flex-start' },
              }}
            />
          )}
        </Flex>

        {/* VIN REELS */}
        <Flex>
          <FormikSwitchField
            extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
            name='isUsingVinReels'
            label={t('VIN Reels')}
            onChange={() => {
              setFieldValue('isUsingVinReels', values.isUsingVinReels ? 0 : 1);
            }}
          />
          {!!values.isUsingVinReels && (
            <FormikInputField
              type='number'
              label={t('Limit')}
              name='maxVinReelsPerMonth'
              isRequired={false}
              labelPosition='left'
              value={
                values.maxVinReelsPerMonth ||
                tempDefaultLimits.maxVinReelsPerMonth
              }
              info={t(
                'If the limit is set to 0, the default value will be applied.'
              )}
              extendStyles={{
                mainWrapper: { gap: '116px', padding: '0 0 0 23px' },
                labelStyles: { alignSelf: 'flex-start' },
              }}
            />
          )}
        </Flex>

        {/* SPOTLIGHT (Flex Video) */}
        <Flex>
          <FormikSwitchField
            extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
            name='spotlightEnabled'
            label={t('AI Flex Video')}
            onChange={() => {
              setFieldValue(
                'spotlightEnabled',
                values.spotlightEnabled ? 0 : 1
              );
            }}
          />
          {!!values.spotlightEnabled && (
            <FormikInputField
              type='number'
              label={t('Limit')}
              name='maxSpotlightPerMonth'
              isRequired={false}
              labelPosition='left'
              value={
                values.maxSpotlightPerMonth ||
                tempDefaultLimits.maxSpotlightPerMonth
              }
              info={t(
                'If the limit is set to 0, the default value will be applied.'
              )}
              extendStyles={{
                mainWrapper: { gap: '116px', padding: '0 0 0 23px' },
                labelStyles: { alignSelf: 'flex-start' },
              }}
            />
          )}
        </Flex>

        {/* QUICK VIDEOS */}
        <FormikSwitchField
          extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
          name='quickVideosEnabled'
          label={t('Quick Videos')}
          onChange={() => {
            setFieldValue(
              'quickVideosEnabled',
              values.quickVideosEnabled ? 0 : 1
            );
          }}
        />

        {/* SUGGESTED CONTENT */}
        <FormikSwitchField
          extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
          name='suggestedContentEnabled'
          label={t('Smart Suggestions')}
          onChange={() => {
            setFieldValue(
              'suggestedContentEnabled',
              values.suggestedContentEnabled ? 0 : 1
            );
          }}
        />

        {/* AI MUSIC */}
        <FormikSwitchField
          extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
          name='aiMusicEnabled'
          label={t('AI Music')}
          onChange={() => {
            setFieldValue('aiMusicEnabled', values.aiMusicEnabled ? 0 : 1);
          }}
        />
      </RowWrapper>
    </Section>
  );
};
